import { render, staticRenderFns } from "./board_type.vue?vue&type=template&id=628a04bc&scoped=true"
import script from "./board_type.vue?vue&type=script&lang=js"
export * from "./board_type.vue?vue&type=script&lang=js"
import style0 from "./board_type.vue?vue&type=style&index=0&id=628a04bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a04bc",
  null
  
)

export default component.exports